export const About = () => (
  <section className="section" id="sobre" data-testid="about-section">
    <div className="container two-col">
      <div>
        <span className="section-tag">EEAT — Quem somos</span>
        <h2>Sobre a Desentope Maresias — Compromisso com o Litoral Paulista</h2>
        <p className="lead">
          Nascemos na Rua das Maritacas, 831, em Maresias — coração da Costa Sul de São
          Sebastião — e construímos nossa operação em torno de uma única especialidade:
          o litoral.
        </p>
        <p>
          Conhecemos os desafios que só quem vive aqui entende: a areia que entope os
          ralos depois de um dia de mar, a maresia que corrói tubulações por dentro das
          paredes, as fossas sépticas dos bairros sem rede coletora e o teste de estresse
          da alta temporada. Atendemos casas de praia, pousadas, hotéis, restaurantes
          litorâneos, quiosques, marinas e condomínios com autoridade técnica para
          emergências hidráulicas no litoral.
        </p>
        <ul className="checks">
          <li>Plantão real 24h, 7 dias — incluindo feriados</li>
          <li>Garantia formal por escrito e nota fiscal</li>
          <li>Descarte 100% licenciado — respeito às APAs e à Mata Atlântica</li>
          <li>Técnicos uniformizados e treinados para imóveis litorâneos</li>
        </ul>
        <a href="/sobre.html" className="card-link" data-testid="about-link">Conheça nossa história</a>
      </div>
      <div>
        <div className="about-badge" aria-hidden="true">
          <b>+ANOS</b>
          <span>DE LITORAL</span>
        </div>
        <div className="img-card">
          <img
            src="/img/tecnico-desentupimento-residencial-litoral.webp"
            alt="Técnico da Desentope Maresias realizando desentupimento de pia em casa de praia no litoral de São Paulo"
            loading="lazy"
            width="540"
            height="360"
          />
        </div>
      </div>
    </div>
  </section>
);
